<template>
    <div class="app-download-prompt">
        <img src="../../assets/level-up-modal/level-4.webp"
            class="kyc-image"
            :alt="$t('global.appRestriction.web.partnerView')"
        >
        <p class="prompt">{{ $t('global.appRestriction.web.partnerUpsell') }}</p>
        <p class="prompt">{{ $t('global.appRestriction.web.partnerUpsellExtended') }}</p>
        <partner-download-app :src="'kyc'" />
    </div>
</template>

<script>
// Components
import partnerDownloadApp from '@webapp/components/download-app/partner-download-app.vue';

export default {
    name: 'kyc-app-download-prompt',
    components: {
        partnerDownloadApp,
    },
};
</script>

<style lang="scss" scoped>
.app-download-prompt {
    text-align: center;
    background-color: $white-color;
    max-width: 600px;
    border-radius: 30px;
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    .kyc-image {
        max-width: 400px;
        height: auto;
    }

    .prompt {
        color: $black-color;
        font-family: "Nunito";
        font-size: 1.5rem;
        font-weight: 400;
        padding: 0 10px;
    }
}
</style>